import React, { useState } from 'react';
import { Box, Typography, Paper, Tabs, Tab, Container, Dialog } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import CategoryList from './CategoryList';
import CategoryForm from './CategoryForm';
import SubCategoryList from './SubCategoryList';
import SubCategoryForm from './SubCategoryForm';

const CategorySettings = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [categoryDialogOpen, setCategoryDialogOpen] = useState(false);
  const [subCategoryDialogOpen, setSubCategoryDialogOpen] = useState(false);

  const handleCategoryEdit = (cat) => {
    setSelectedCategory(cat);
    setCategoryDialogOpen(true);
  };
  
  const handleSubCategoryEdit = (sub) => {
    setSelectedSubCategory(sub);
    setSubCategoryDialogOpen(true);
  };

  const handleCategorySuccess = () => {
    setSelectedCategory(null);
    setCategoryDialogOpen(false);
    setRefresh(!refresh);
  };

  const handleSubCategorySuccess = () => {
    setSelectedSubCategory(null);
    setSubCategoryDialogOpen(false);
    setRefresh(!refresh);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setSelectedCategory(null);
    setSelectedSubCategory(null);
  };

  const handleAddCategory = () => {
    setSelectedCategory(null);
    setCategoryDialogOpen(true);
  };

  const handleAddSubCategory = () => {
    setSelectedSubCategory(null);
    setSubCategoryDialogOpen(true);
  };

  return (
    <Container className="settings-page" maxWidth="xl" sx={{ mt: 2, mb: 2, px: 2 }}>
      <Box className="settings-heading" sx={{ mb: 2 }}>
        <Typography 
          variant="h6" 
          sx={{ 
            fontWeight: 600,
            color: 'text.primary',
            mb: 0.5,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            fontSize: '1rem'
          }}
        >
          <CategoryIcon sx={{ fontSize: 24, color: '#1976d2' }} />
          Category Management
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
          Manage your product categories and sub-categories
        </Typography>
      </Box>

      <Paper className="settings-shell" sx={{ 
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 1
      }}>
        <Tabs 
          value={activeTab} 
          onChange={handleTabChange}
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            bgcolor: 'grey.50'
          }}
        >
          <Tab 
            icon={<CategoryIcon />} 
            iconPosition="start" 
            label="Categories" 
            sx={{ 
              fontWeight: 600,
              fontSize: '0.85rem'
            }} 
          />
          <Tab 
            icon={<SubdirectoryArrowRightIcon />} 
            iconPosition="start" 
            label="Sub-Categories" 
            sx={{ 
              fontWeight: 600,
              fontSize: '0.85rem'
            }} 
          />
        </Tabs>

        <Box className="settings-content" sx={{ p: 2 }}>
          {activeTab === 0 && (
            <Box>
              <CategoryList 
                onEdit={handleCategoryEdit} 
                onAdd={handleAddCategory}
                key={refresh} 
              />
            </Box>
          )}

          {activeTab === 1 && (
            <Box>
              <SubCategoryList 
                onEdit={handleSubCategoryEdit} 
                onAdd={handleAddSubCategory}
                key={refresh + 'sub'} 
              />
            </Box>
          )}
        </Box>
      </Paper>

      {/* Category Dialog */}
      <Dialog 
        open={categoryDialogOpen} 
        onClose={() => {
          setCategoryDialogOpen(false);
          setSelectedCategory(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <CategoryForm 
          selected={selectedCategory} 
          onSuccess={handleCategorySuccess} 
          onCancel={() => {
            setCategoryDialogOpen(false);
            setSelectedCategory(null);
          }} 
        />
      </Dialog>

      {/* Sub-Category Dialog */}
      <Dialog 
        open={subCategoryDialogOpen} 
        onClose={() => {
          setSubCategoryDialogOpen(false);
          setSelectedSubCategory(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <SubCategoryForm 
          selected={selectedSubCategory} 
          onSuccess={handleSubCategorySuccess} 
          onCancel={() => {
            setSubCategoryDialogOpen(false);
            setSelectedSubCategory(null);
          }} 
        />
      </Dialog>
    </Container>
  );
};

export default CategorySettings;
